export const modifyPrecision = (value: bigint, from: bigint, to: bigint) => {
  return (value * 10n ** to) / 10n ** from
}
